<template>
<div class="chapter">
<div class="inner_page">
<p class="copy" id="copy">Copyright</p>
<p class="copy1">Hell and Beyond: A Novel</p>
<p class="copy1">Copyright © 2012 by Michael Phillips</p>
<p class="copy1">Cover art to the electronic edition copyright © 2012 by Bondfire Books LLC.</p>
<p class="copy2">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</p>
<p class="copy2">See full line of eBook originals at www.bondfirebooks.com.</p>
<p class="copy2">Author is represented by Alive Communications, Inc., 7680 Goddard St., Suite 200, Colorado Springs, CO 80920.</p>
<p class="copy2">Electronic edition published 2012 by Bondfire Books LLC, Colorado.</p>
<p class="copy1">Cover jacket design by Alexia Garaventa.</p>
<p class="copy1">ISBN ePub edition: 9780795333255</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split2.vue?349bed21